import types from './types';
import create from '~/misc/create';

export const selectTab = (id, selectedTab) =>
  create(types.SELECT_TAB, {id, selectedTab});



// WEBPACK FOOTER //
// ./src/modules/tabs/actions.js